export default __webpack_public_path__ + "static/media/about-coffeebags.817bea85.jpg";